import api from "~/services/api";

const CONTROLLER_NAME = "/booking_transaction";
const CONTROLLER_NAME_BOOKING_STATUS = "booking";
const CLIENT_CONTROLLER_NAME_BOOKING = "client/booking";
const CLIENT_CONTROLLER_NAME_BOOKING_TRANSACTION = "client/booking_transaction";

export const postBookingTransaction = (body) => {
	return api.post(CONTROLLER_NAME, body);
};
export const getBookingTransaction = (id) => {
	return api.get(`${CONTROLLER_NAME}/?user_id=${id}`);
};
export const getBusinessBookingTransaction = (userId, businessId, language, pageIndex, upcoming = false) => {
	let url = `${CONTROLLER_NAME}/?user_id=${userId}&validate_packages=true&language=${language}&page_index=${pageIndex}`;
	if (upcoming) {
		url += `&upcoming=3`;
	}
	if (businessId) {
		url += `&business_id=${businessId}`;
	}
	return api.get(url);
};
export const putBookingStatus = (id, reason, status, cancellationReason, confirmReservation) => {
	return api.put(`${CONTROLLER_NAME_BOOKING_STATUS}/${id || ""}`, {
		booking: {
			status,
			reason,
			cancellationReason,
			confirmReservation,
		},
	});
};

// PUT /client/booking/:id aceita só dois payloads:
// { confirm_reservation: true } ou { status: "cancelled", cancellation_reason: "client", reason }
export const putClientBookingConfirm = (id) => {
	return api.put(
		`${CLIENT_CONTROLLER_NAME_BOOKING}/${id || ""}`,
		{ booking: { confirm_reservation: true } }
	);
};

export const putClientBookingCancel = (id, reason) => {
	return api.put(
		`${CLIENT_CONTROLLER_NAME_BOOKING}/${id || ""}`,
		{ booking: { status: "cancelled", cancellation_reason: "client", ...(reason ? { reason } : {}) } }
	);
};

export const putBookingTransaction = (id, payment_status, cancellationReason) => {
	return api.put(`${CONTROLLER_NAME}/${id || ""}`, {
		payment_status: payment_status || "cancelled",
		cancellation_reason: cancellationReason || "payment_error",
	});
};

export const getBookingRescheduleValidByBookingId = (id, config) => {
	return api.get(
		"booking/reschedule_valid/",
		{
			params: { booking_id: id },
		},
		config
	);
};

export const putBookingUpdateSchedule = ({ bookingId, data }) => {
	return api.put(`booking/${bookingId}/update_schedule`, data);
};

export const getOneBookingTransaction = (id, language) => {
	let url = `booking_transaction/${id}`;
	if (language) {
		url += `?language=${language}`;
	}
	return api.get(url);
};
export const getClientBookingTransaction = (id, language) => {
	let url = `${CLIENT_CONTROLLER_NAME_BOOKING_TRANSACTION}/${id}`;
	if (language) {
		url += `?language=${language}`;
	}
	return api.get(url);
};
export const publishBooktranscation = (id) => {
	return api.post(`${process.env.REACT_APP_URL_API_PAYOUT}bookingtransaction/publish/prit-pay/${id}`);
};

export const checkSlotBookingTransaction = (slots) => {
	return api.post(`${CONTROLLER_NAME}/check_slot`, { slots });
};

export default {
	postBookingTransaction,
	getBookingTransaction,
	putBookingStatus,
	getBookingRescheduleValidByBookingId,
	putBookingUpdateSchedule,
	getOneBookingTransaction,
	getClientBookingTransaction,
	putClientBookingConfirm,
	putClientBookingCancel,
	publishBooktranscation,
	putBookingTransaction,
};
